<template>
  <div>
    <div class="header" :class="{ map: path.includes('map') }">
      <img v-if="path.includes('map')" class="logo" @click="$router.replace('/')" src="@/assets/images-front/logo-colorful.png" alt="logo" />
      <img v-else class="logo" @click="$router.replace('/')" src="@/assets/images-front/logo.png" alt="logo" />
      <div class="nav-box">
        <template>
          <router-link to="/" class="nav-item" :class="{ active: path == '/index' || path == '/index/' }">系统介绍</router-link>
          <router-link to="/index-rj/" class="nav-item" :class="{ active: path.includes('index-rj') }">人居环境</router-link>
          <router-link to="/index-xh/" class="nav-item" :class="{ active: path.includes('index-xh') }">河长巡河</router-link>
          <router-link to="/index-about/" class="nav-item" :class="{ active: path.includes('index-about') }">关于我们</router-link>
        </template>
      </div>
      <el-dropdown v-if="path.includes('map') && userInfo" class="user-info" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ userInfo.nickname }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-if="!path.includes('map')" class="no-login">
        <router-link to="/map" class="login-btn">
          <div class="iconfont icon-user"></div>
          <div>登录</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      path: this.$route.path,
      userInfo: null,
    };
  },

  computed: {
    ...mapState({
      loginStatus: (state) => state.user.loginStatus,
    }),
  },

  created() {
    if (this.path.includes('map')) {
      if (this.loginStatus != 1) {
        this.$router.replace('/login');
      } else {
        this.getUserInfo();
      }
    }
  },

  methods: {
    async getUserInfo() {
      try {
        let res = await this.api.user.info();
        this.userInfo = res.data.user_info;
        this.$emit('success');
      } catch (e) {
        console.error(e);
      }
    },

    async handleCommand(command) {
      if (command === 'logout') {
        await this.$confirm('确认退出登录么?', '提示');
        this.$store.dispatch('user/logout');
      }
    },
  },
};
</script>

<style scoped>
.header {
  color: #fff;
  font-size: 18px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;
}
.header.map {
  background: #fff;
}

.logo {
  display: block;
  width: 140px;
}

.nav-box {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
}

.nav-item {
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  font-size: 16px;
  text-align: center;
  margin-right: 50px;
}
.nav-item:last-child {
  margin-right: 0;
}

.nav-item.active:after {
  content: '';
  position: absolute;
  height: 1px;
  width: 70px;
  background: #fff;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}
.header.map .nav-item {
  color: #000;
}
.header.map .nav-item.active:after {
  background: #000;
}

.user-info .el-dropdown-link {
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}

.header.map .user-info .el-dropdown-link {
  color: #000;
}

.no-login {
  display: flex;
  justify-content: flex-end;
}

.login-btn {
  width: 140px;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  text-decoration: none;
}
.login-btn .iconfont {
  margin-right: 7px;
}
</style>
